import { WorkspaceType } from "./workspace";

export enum IntegrationStatus {
  connecting = "connecting",
  connected = "connected",
  broken = "broken",
  disconnected = "disconnected",
}

export enum IntegrationStyle {
  custom = "custom",
  oauth = "oauth",
}

export interface Integration {
  id: number;
  "workspace-id": number;
  integration: string;
  status: IntegrationStatus;
  style: IntegrationStyle;
  "access-token": string;
  "refresh-token": string | null;
  data: Record<string, any>;
  "created-at": string;
  "updated-at": string;
}

export interface IntegrationSchema {
  id: string;
  label: string;
  style: IntegrationStyle;
  status: IntegrationStatus;
  // When the OAuth refresh token expires, ISO8601. Null unless the
  // provider reports one -- only LinkedIn does today.
  "expires-at": string | null;
  context: IntegrationContextField[];
  "workspace-types": WorkspaceType[];
}

export enum IntegrationContextFieldType {
  AccessToken = "access-token",
  FacebookCAPIDataset = "facebook-capi-dataset-id",
  ShopifyShopURL = "shopify-shop-url",
  ShopifyAccessToken = "shopify-access-token",
  Text = "text",
}

export interface IntegrationContextField {
  id: string;
  label: string;
  type: IntegrationContextFieldType;
  required?: boolean;
}
